var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "cc628224-92a6-4d0d-9dc3-fe0f89e7254b",
    version: "0.0.4",
    organization: "Tina",
    project: "LearnPage",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/LearnPage",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/7ccc2013-ef9a-4bd4-bc8c-0eed8a54e5d2/50f3dd5aa4acacabe79e12bf8506a9ce1918629a/",
    core: "4.5.0",
    title: "Zigzag",
    type: "haiku",
    relpath: "code/zigzag/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Rectangle-Copy-3-b6e457f5865961c2": {
        x: 37.6100213,
        y: 71.8208402,
        width: 9,
        height: 128,
        rx: 4.5,
        fill: { "0": { value: "#FFAC39", edited: true } }
      },
      "haiku:Zigzag-9602d6081741bb40": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": { "0": { value: "hidden", edited: true } },
        "style.overflowY": { "0": { value: "hidden", edited: true } },
        "sizeAbsolute.x": 616.11,
        "sizeAbsolute.y": 350,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Group-a94a9e23c29874d8": {
        fill: "#CD3172",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd",
        "translation.x": -289.671,
        "translation.y": 3.039
      },
      "haiku:Rectangle-a4bba94ae83341bf": {
        x: 289.671181,
        y: -3.03855489,
        width: 9,
        height: 75,
        rx: 4.5,
        fill: { "0": { value: "#FFAC39", edited: true } }
      },
      "haiku:Rectangle-Copy-e41acb479d44d8bd": {
        "sizeMode.x": 1,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": {
          "0": {
            value: 543.9794116828646,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": {
            value: 539.7097469594667,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1083": { value: 508.029, edited: true }
        },
        "translation.y": {
          "0": {
            value: 135.9699916833669,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": {
            value: 132.32299666259908,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1083": { value: 106.873, edited: true }
        },
        "rotation.z": 5.393,
        "sizeAbsolute.x": 9,
        "style.position": "absolute",
        "sizeAbsolute.y": 91,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        "scale.y": {
          "0": { value: -0.017, edited: true, curve: "easeInOutQuad" },
          "500": { value: 0.107, edited: true, curve: "easeInOutQuad" },
          "1083": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: -1.002, edited: true, curve: "easeInOutQuad" },
          "500": { value: 0.969 }
        },
        "rotation.x": 3.142,
        "scale.z": -1,
        opacity: {
          "0": { value: 0, edited: true },
          "500": { value: 0, edited: true, curve: "easeInOutQuad" },
          "517": { value: 1, edited: true },
          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 0, edited: true }
        }
      },
      "haiku:Group-38e05b604020069d": {
        fill: "#CD3172",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd",
        "translation.x": -240.692,
        "translation.y": 8.369
      },
      "haiku:Rectangle-Copy-bab689546f4f2afe": {
        x: 240.692083,
        y: -8.36876538,
        width: 9,
        height: 91,
        rx: 4.5,
        fill: { "0": { value: "#FFAC39", edited: true } }
      },
      "haiku:Rectangle-Copy-2-f4da62dbf5b504e1": {
        "sizeMode.x": 1,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": {
          "0": {
            value: 477.90296108362406,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1083": {
            value: 475.99264317059755,
            curve: "easeInOutQuad",
            edited: true
          },
          "1917": { value: 408.219, edited: true }
        },
        "translation.y": {
          "0": {
            value: 77.62214398886388,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1083": {
            value: 80.57156873831501,
            curve: "easeInOutQuad",
            edited: true
          },
          "1917": { value: 166.852, edited: true }
        },
        "rotation.z": 0.663,
        "sizeAbsolute.x": 9,
        "style.position": "absolute",
        "sizeAbsolute.y": 227,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        "scale.y": {
          "0": { value: 0.002, edited: true, curve: "easeInOutQuad" },
          "1083": { value: 0.033, curve: "easeInOutQuad", edited: true },
          "1917": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
          "1083": { value: 1.07 }
        },
        "rotation.x": { "0": { value: 0, edited: true }, "1083": { value: 0 } },
        "scale.z": { "0": { value: 1, edited: true }, "1083": { value: 1 } },
        opacity: {
          "0": { value: 0, edited: true },
          "1083": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1100": { value: 1, edited: true },
          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 0, edited: true }
        }
      },
      "haiku:Group-0a1d765af70cc326": {
        fill: "#CD3172",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd",
        "translation.x": -140.924,
        "translation.y": 16.29
      },
      "haiku:Rectangle-Copy-2-8869d66e15e6d966": {
        x: 140.923626,
        y: -16.2903028,
        width: 9,
        height: 227,
        rx: 4.5,
        fill: { "0": { value: "#FFAC39", edited: true } }
      },
      "haiku:Rectangle-Copy-3-0642f7addbaff76e": {
        "sizeAbsolute.x": 9,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": {
          "0": {
            edited: true,
            value: 343.9483070326498,
            curve: "easeInOutQuad"
          },
          "1917": {
            value: 341.1600322332426,
            curve: "easeInOutQuad",
            edited: true
          },
          "2583": { value: 304.882, edited: true }
        },
        "translation.y": {
          "0": {
            edited: true,
            value: 255.83495592402147,
            curve: "easeInOutQuad"
          },
          "1917": {
            value: 253.58846591040125,
            curve: "easeInOutQuad",
            edited: true
          },
          "2583": { value: 205.454, edited: true }
        },
        "rotation.z": 2.496,
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 127.99999237060547,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        "scale.y": {
          "0": { value: 0.004, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 0.058, curve: "easeInOutQuad", edited: true },
          "2583": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 0.802, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 0.997 }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "1917": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1933": { value: 1, edited: true },
          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 0, edited: true }
        }
      },
      "haiku:Group-5a5deb87f9ce2813": {
        fill: "#CD3172",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd",
        "translation.x": -37.61,
        "translation.y": -71.821
      },
      "haiku:Rectangle-b6882ed2d7651795": {
        "rotation.z": 0.541,
        "style.overflow": "visible",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": {
          "0": {
            value: 576.2175043009057,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": { value: 556.937, edited: true }
        },
        "translation.y": {
          "0": {
            value: 72.1992476535478,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": { value: 104.103, edited: true }
        },
        "style.position": "absolute",
        "sizeAbsolute.x": 9,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 75,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        "scale.x": 1.021,
        "scale.y": {
          "0": { value: 0.006, edited: true, curve: "easeInOutQuad" },
          "500": { value: 1, curve: "easeInOutQuad", edited: true }
        },
        opacity: {
          "0": { value: 1, edited: true },
          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "3000": { value: 0, edited: true }
        }
      },
      "haiku:Hand3-Copy-dc115316fd57b733": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 72,
        "style.margin": "0",
        "sizeAbsolute.y": 260,
        "sizeMode.y": 1,
        "translation.x": {
          "0": {
            value: 530.0889999999999,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": { value: 495.041, edited: true, curve: "easeInOutQuad" },
          "1083": { value: 440, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 297.412, edited: true, curve: "easeInOutQuad" },
          "2583": { value: 241.236, edited: true, curve: "linear" },
          "2750": { value: 108.236 }
        },
        "translation.y": {
          "0": {
            value: -52.37785339355469,
            edited: true,
            curve: "easeInOutQuad"
          },
          "500": {
            value: 5.970001220703125,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1083": {
            value: -60.35975646972656,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1917": {
            value: 123.45904541015625,
            edited: true,
            curve: "easeInOutQuad"
          },
          "2583": { value: 21.135025024414062, edited: true, curve: "linear" },
          "2750": { value: -156 }
        },
        "style.zIndex": 5,
        "scale.x": {
          "0": { value: 1, edited: true },
          "2533": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2583": { value: 1.2, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "2533": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2583": { value: 1.2, edited: true }
        }
      },
      "haiku:Page-1-483864ff6acde524": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-3ffbeb8a0fddcf6b": {
        "translation.x": -414,
        "translation.y": -35
      },
      "haiku:Hand3-Copy-b78475a1c4137440": {
        "translation.x": 414,
        "translation.y": 35
      },
      "haiku:Path-9-a490d20d705851f5": {
        d:
          "M39.3854167,222.782925 C41.8095682,223.717565 43.9126285,223.717565 45.6945977,222.782925 C47.4765668,221.848285 48.9072494,219.994842 49.9866453,217.222597 C51.7783901,212.70853 53.6650639,210.77419 55.6466668,211.419578 C57.6282696,212.064966 58.3122666,214.377781 57.6986579,218.358023 C57.0131832,224.269159 56.1482713,227.787196 55.1039223,228.912132 C54.0595733,230.037068 50.9231317,232.260705 45.6945977,235.583043 C55.0746311,234.065823 60.8325231,233.151071 62.9682738,232.838787 C66.1718997,232.370361 68.3344814,232.867475 68.8314389,234.912372 C69.3283964,236.957268 67.747062,237.843563 65.8072309,239.112687 C64.5140102,239.95877 56.9283789,242.688497 43.0503369,247.301869 L39.3854167,222.782925 Z",
        fill: "#FA9E92"
      },
      "haiku:Path-8-e0ca3994bd8dbe7e": {
        d:
          "M0.764717332,0.900110587 C5.03958184,26.2139532 26.0041046,141.834322 26.9439641,151.390145 C27.6510443,156.665964 26.8808707,157.980698 27.3477175,162.064161 C27.8145642,166.147624 29.1011262,167.484833 29.1011262,169.62329 C29.1011262,171.761746 28.8916093,174.823895 25.1929701,185.91231 C21.4943309,197.000726 18.2225875,202.280207 16.7226852,206.055401 C15.2227829,209.830595 13.4796524,211.02146 13.4796524,214.519154 C13.4796524,218.016847 15.9695619,219.435076 16.4529037,221.252374 C16.7751315,222.463906 16.7751315,225.62089 16.4529037,230.723325 C16.5219435,232.242887 16.7553132,233.379195 17.1530126,234.132249 C17.5507121,234.885303 18.4948112,235.70319 19.9853101,236.585911 L29.1011262,242.118693 L30.4839933,246.868274 C30.940598,248.6227 31.6632433,249.963635 32.6519289,250.891077 C33.6406146,251.81852 34.6992728,252.148548 35.8279037,251.881161 L43.6915397,240.552292 C42.0830224,236.492925 41.3068764,233.025619 41.3631016,230.150373 C41.4474395,225.837503 43.0781521,221.921504 44.088634,220.245685 C45.0991159,218.569866 49.0810142,213.476985 51.8882682,214.210085 C53.7597709,214.698818 59.2778439,214.03659 68.442487,212.223401 C68.2509922,208.140237 68.0357145,205.358891 67.7966537,203.879363 C67.5316218,202.239102 62.4929254,185.973182 58.9017554,171.794349 C57.6340299,166.789054 59.932177,98.5747279 59.932177,81 C59.932177,69.2835147 59.6111363,42.5835516 58.9690549,0.900110587 C29.4856585,0.900110587 10.0842127,0.900110587 0.764717332,0.900110587 Z",
        fill: "#FDCEC9"
      },
      "haiku:Pencil3-02ff82ac18558d6e": {
        "translation.x": 63.610432,
        "translation.y": 162.537872,
        "rotation.z": 1.48353
      },
      "haiku:Rectangle-2490c7b976de23d5": {
        d:
          "M37.4316383,-18.3512276 L48.9846906,-18.314377 L49.2649883,69.0914794 C49.269579,70.5229941 48.1128285,71.6871875 46.6813138,71.6917782 C46.6757872,71.6917959 46.6702606,71.691796 46.664734,71.6917783 L40.2957613,71.6714633 C38.870717,71.6669179 37.7166122,70.5128328 37.7120423,69.0877886 L37.541863,16.0204138 L37.4316383,-18.3512276 Z",
        fill: "#212D31",
        "translation.x": 49.200012,
        "translation.y": -23.887987,
        "rotation.z": 1.134464
      },
      "haiku:Path-4-4fdd7cb2a14377a2": {
        d:
          "M86.286679,12.811054 L81.4151558,2.41912722 L93.2509246,0.472905215 C95.6448543,-0.0922552186 97.0387556,0.0175058431 97.4326287,0.8021884 C97.8265017,1.58687096 97.3139278,2.6584951 95.894907,4.01706082 L86.286679,12.811054 Z",
        fill: "#FFAC39"
      },
      "haiku:Path-8-Copy-744fa2fa3c341a08": {
        d:
          "M16.7951161,206.173555 C15.2952138,209.948749 13.5520833,211.139614 13.5520833,214.637307 C13.5520833,218.135001 16.0419928,219.55323 16.5253346,221.370528 C16.8475624,222.58206 16.8475624,225.739044 16.5253346,230.841479 C16.5943744,232.361041 16.8277441,233.497349 17.2254435,234.250403 C17.623143,235.003457 18.5672421,235.821344 20.057741,236.704065 L29.1735571,242.236847 L30.5564242,246.986428 C31.0130289,248.740854 31.7356742,250.081789 32.7243598,251.009231 C33.7130455,251.936674 34.7717037,252.266701 35.9003346,251.999315 C44.2670346,251.339259 50.9622063,251.339259 55.9858495,251.999315 C58.9829439,252.393103 61.9365096,252.738387 61.9365096,249.495894 C61.9365096,247.149371 60.2826228,245.055014 56.9748493,243.212825 L43.7639706,240.670445 C42.1554533,236.611079 41.3793073,233.143772 41.4355325,230.268526 C41.5198704,225.955657 18.2950184,202.39836 16.7951161,206.173555 Z",
        fill: "#FDCEC9"
      },
      "haiku:Path-8-Copy-2-61a94edc42ffb6cd": {
        d:
          "M51.9481442,214.095199 C54.7553982,214.828299 56.2459671,217.798009 57.3098599,222.860909 C58.0191218,226.236176 58.1146739,230.772881 57.5965163,236.471026 C57.6011588,241.715201 59.0436383,244.337289 61.9239546,244.337289 C66.2444292,244.337289 66.5432087,238.030437 67.1998692,236.142764 C67.6376428,234.884316 68.7433721,233.039541 70.5170571,230.60844 C71.4500758,229.632963 71.9165852,228.408904 71.9165852,226.936263 C71.9165852,225.463622 70.7785111,220.521039 68.5023629,212.108515 C68.3108682,208.025352 68.0955904,205.244006 67.8565296,203.764478 C67.4979384,201.545185 49.1408901,213.362099 51.9481442,214.095199 Z",
        fill: "#FDCEC9"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Zigzag-9602d6081741bb40",
      "haiku-title": "Zigzag"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Hand3-Copy-dc115316fd57b733",
          "haiku-title": "hand3 copy",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/hand3 copy.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-483864ff6acde524", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-3ffbeb8a0fddcf6b",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Hand3-Copy-b78475a1c4137440",
                      id: "hand3-copy"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-9-a490d20d705851f5",
                          id: "Path-9"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-8-e0ca3994bd8dbe7e",
                          id: "Path-8"
                        },
                        children: []
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Pencil3-02ff82ac18558d6e",
                          id: "pencil3"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Rectangle-2490c7b976de23d5",
                              id: "Rectangle"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-4-4fdd7cb2a14377a2",
                              id: "Path-4"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-8-Copy-744fa2fa3c341a08",
                          id: "Path-8-Copy"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-8-Copy-2-61a94edc42ffb6cd",
                          id: "Path-8-Copy-2"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Rectangle-Copy-3-0642f7addbaff76e",
          "haiku-title": "Rectangle-Copy-3",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-5a5deb87f9ce2813" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "Rectangle-Copy-3-b6e457f5865961c2",
                  "haiku-title": "Rectangle-Copy-3"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Rectangle-Copy-2-f4da62dbf5b504e1",
          "haiku-title": "Rectangle-Copy-2",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-0a1d765af70cc326" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "Rectangle-Copy-2-8869d66e15e6d966",
                  "haiku-title": "Rectangle-Copy-2"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Rectangle-Copy-e41acb479d44d8bd",
          "haiku-title": "Rectangle-Copy",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-38e05b604020069d" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "Rectangle-Copy-bab689546f4f2afe",
                  "haiku-title": "Rectangle-Copy"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Rectangle-b6882ed2d7651795",
          "haiku-title": "Rectangle",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-a94a9e23c29874d8" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "Rectangle-a4bba94ae83341bf",
                  "haiku-title": "Rectangle"
                },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-learnpage/code/zigzag/code.js
// module id = 468
// module chunks = 127651196306611